import axios, { AxiosResponse } from 'axios';

let keycloakToken = '';

export const syncToken = (token: string) => {
  keycloakToken = token;
};

export const initAxios = (): void => {
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.interceptors.request.use(
    (axiosRequestConfig) => {
      if (!axiosRequestConfig.headers) {
        axiosRequestConfig.headers = {};
      }
      if (keycloakToken) {
        axiosRequestConfig.headers.authorization = `Bearer ${keycloakToken}`;
      }
      // axiosRequestConfig.headers['X-Request-ID'] = uuidv4();
      return axiosRequestConfig;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
};

export interface BaseRequestParameters {
  csrfToken: string;
}

// Factory function to produce a function doing a POST to the given url, with the data passed as URL parameters.
export function makePostWithParameters<Parameters extends BaseRequestParameters, ResponseType>(
  url: string,
) {
  return async ({ csrfToken, ...params }: Parameters) => {
    const result: AxiosResponse<ResponseType> = await axios({
      method: 'post',
      url,
      params,
      headers: { 'X-CSRF-Token': csrfToken },
    });
    // just in case axios returns null/undefined
    if (result) {
      return result.data;
    } else {
      return Promise.reject(new Error(`Internal error while posting to ${url}`));
    }
  };
}

export interface RequestData<Data> {
  csrfToken: string;
  data: Data;
}

// Factory function to produce a function doing a POST to the given url, with the data passed in the body.
export function makePostWithData<Data, ResponseType>(url: string) {
  return async ({ csrfToken, data }: RequestData<Data>) => {
    const result: AxiosResponse<ResponseType> = await axios({
      method: 'post',
      url,
      data,
      headers: { 'X-CSRF-Token': csrfToken },
    });
    // just in case axios returns null/undefined
    if (result) {
      return result.data;
    } else {
      return Promise.reject(new Error('Internal error while saving Adyen credit card'));
    }
  };
}
